<template>
    <video id="videoContainer" class="video-js" :style="{width: '100%', height: '100%'}">
        <source :src="data" type="video/mp4">
    </video>
</template>

<style type="text/css">
    .vjs-big-play-button{
        font-size: 5em !important;
        left: 50% !important;
        top: 50% !important;
        width: 80px !important;
        height: 80px !important;
        border-width: 1px !important;
        border-radius: 50% !important;
        transform: translate(-50%, -50%) !important;
    }
</style>

<script type="text/javascript">
    export default {
        data () {
            return {
                videoPlayer: null,
            }
        },
        props: ['data'],
        created() {
        },
        mounted() {
            console.log('videoURl:', this.data);
            this.readyVideoPlayer();
        },
        methods: {
            readyVideoPlayer() {
                //初始化视频
                this.videoPlayer = this.$video('#videoContainer', {
                    controls: true, // 启用控件
                    autoplay: false, // 自动播放属性, muted:静音播放
                    preload: 'auto', // 是否应在<video>挂载后立即下载视频
                });
            },
            __dispose(){
                this.videoPlayer.dispose();
            }
        },
        beforeDestroy() {
            this.__dispose();
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/VideoPlayer.vue